import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

// Debounced keyless metadata lookup (iTunes / MusicBrainz via backend).
export function useLookup(endpoint, term, minLen = 2) {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const timer = useRef();

  useEffect(() => {
    clearTimeout(timer.current);
    if (!term || term.trim().length < minLen) {
      setResults([]);
      return;
    }
    timer.current = setTimeout(async () => {
      setLoading(true);
      try {
        const { data } = await api.get(`/lookup/${endpoint}`, { params: { term } });
        setResults(data.results || []);
      } catch {
        setResults([]);
      } finally {
        setLoading(false);
      }
    }, 400);
    return () => clearTimeout(timer.current);
  }, [term, endpoint, minLen]);

  return { results, loading };
}
